import RestResource from '../rest.service';
export default class CropsService extends RestResource {
  constructor(api) {
    super(api, 'crops', 'api');
  }
}
